
import React from "react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";

interface StackedBarChartProps {
  data: Array<any>;
  keys: Array<{
    dataKey: string;
    name: string;
    color: string;
  }>;
  nameKey?: string;
  height?: number | string;
  margin?: { top: number; right: number; left: number; bottom: number };
}

const StackedBarChart: React.FC<StackedBarChartProps> = ({
  data,
  keys,
  nameKey = "name",
  height = "100%",
  margin = { top: 5, right: 30, left: 20, bottom: 5 }
}) => {
  return (
    <div className="h-80 w-full">
      <ResponsiveContainer width="100%" height={height}>
        <BarChart
          data={data}
          margin={margin}
          barCategoryGap={16}
        >
          <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
          <XAxis 
            dataKey={nameKey}
            tick={{ fill: '#4B5563', fontSize: 12 }}
            tickLine={{ stroke: '#9CA3AF' }}
            axisLine={{ stroke: '#9CA3AF' }}
            padding={{ left: 10, right: 10 }}
          />
          <YAxis 
            tick={{ fill: '#4B5563', fontSize: 12 }}
            tickLine={{ stroke: '#9CA3AF' }}
            axisLine={{ stroke: '#9CA3AF' }}
          />
          <Tooltip 
            wrapperStyle={{ 
              backgroundColor: 'white', 
              border: '1px solid #ccc', 
              borderRadius: '6px',
              boxShadow: '0px 4px 6px -1px rgba(0, 0, 0, 0.1)' 
            }}
            contentStyle={{ 
              padding: '10px', 
              borderRadius: '6px',
              fontSize: '12px'
            }}
          />
          <Legend 
            wrapperStyle={{ paddingTop: '10px' }}
            iconType="circle"
            iconSize={10}
            formatter={(value) => <span className="text-sm font-medium">{value}</span>}
          />
          {keys.map((key, index) => (
            <Bar 
              key={key.dataKey} 
              dataKey={key.dataKey} 
              name={key.name} 
              stackId="a" 
              fill={key.color}
              radius={index === keys.length - 1 ? [4, 4, 0, 0] : [0, 0, 0, 0]} 
              animationDuration={800 + (index * 100)}
              animationEasing="ease-out"
              className="hover:opacity-80 transition-opacity duration-300"
              style={{ filter: 'drop-shadow(0px 2px 2px rgba(0, 0, 0, 0.1))' }}
            />
          ))}
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default StackedBarChart;
